module.exports = __webpack_public_path__ + "static/Trailer-0862b2cc4337f6bb856cafc02b3c7a80.mp4";